export default {
  development: {
    // api: "http://yapi.ywfe.com/mock/91",
    api: "http://192.168.122.132:8013",
    // api: "http://supplyapi.test.ywwl.com",
    loginHost: 'http://172.16.5.211:8022',
    static: "/"
  },
  dev: {
    // api: "https://dev-gw.ywwl.com",
    api: "https://dev-supply-chain.ywwl.com",
    loginHost: 'http://172.16.5.211:8022',
    static: "/"
  },
  test: {
    api: "https://test-supply-chain.ywwl.com",
    loginHost: 'http://172.16.5.175:8022',
    static: "/"
  },
  prod: {
    api: "https://supply-chain.ywwl.com",
    loginHost: 'http://oper.98u.com',
    static: "/"
  }
}
